import { ReactElement } from 'react';

import Subscription from '~components/Subscription';

import DashboardVariantV2CarrierContentCollectTabProvider from './Context';

import {
  DashboardVariantV2CarrierContentTabContainer,
  DashboardVariantV2CarrierContentWrapper,
} from '../../styles';

import {
  DashboardVariantV2CarrierContentCollectTabActions,
  DashboardVariantV2CarrierContentCollectTabCurrenFilters,
  DashboardVariantV2CarrierContentCollectTabDataTable,
  DashboardVariantV2CarrierContentCollectTabMap,
} from './Components';

const DashboardVariantV2CarrierContentCollectTab = (): ReactElement => (
  <DashboardVariantV2CarrierContentCollectTabProvider>
    <DashboardVariantV2CarrierContentTabContainer>
      <DashboardVariantV2CarrierContentCollectTabActions />

      <DashboardVariantV2CarrierContentCollectTabCurrenFilters />

      <div>
        <Subscription.AvailableRoutesState.Alert
          withButtons
          withCloseAction
          sx={(currentTheme) => ({
            padding: currentTheme.spacing(0, 2, 2, 2),
          })}
        />
      </div>

      <DashboardVariantV2CarrierContentWrapper>
        <DashboardVariantV2CarrierContentCollectTabDataTable />

        <DashboardVariantV2CarrierContentCollectTabMap />
      </DashboardVariantV2CarrierContentWrapper>
    </DashboardVariantV2CarrierContentTabContainer>
  </DashboardVariantV2CarrierContentCollectTabProvider>
);

export default DashboardVariantV2CarrierContentCollectTab;
